import { render, staticRenderFns } from "./LivingAndCommercialSpace.vue?vue&type=template&id=26fd4937&scoped=true&"
import script from "./LivingAndCommercialSpace.vue?vue&type=script&lang=js&"
export * from "./LivingAndCommercialSpace.vue?vue&type=script&lang=js&"
import style0 from "./LivingAndCommercialSpace.vue?vue&type=style&index=0&id=26fd4937&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fd4937",
  null
  
)

export default component.exports